<template>
  <div
    class="flex items-center cursor-pointer toggle"
    :class="currentValue ? 'checked' : ''"
    for="toggle"
    @click="toggle"
  >
    <Tooltip direction="left" extend-width="true" :message="textLeftTooltip">
      <div class="mr-3 font-medium text-gray-600 text-sm">
        {{ textLeft }}
      </div>
    </Tooltip>
    <div class="relative">
      <div class="bg block bg-gray-200 w-12 h-7 rounded-full"></div>
      <div
        class="dot absolute left-1 bg-white top-1 w-5 h-5 rounded-full transition"
      />
    </div>
    <Tooltip direction="right" extend-width="true" :message="textRightTooltip">
      <div class="ml-3 font-medium text-gray-600 text-sm">
        {{ textRight }}
      </div>
    </Tooltip>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Tooltip from '@/components/general/Tooltip.vue';

export default defineComponent({
  name: 'Switch',
  components: {
    Tooltip,
  },
  emits: ['toggle'],
  props: {
    currentValue: {
      type: Boolean,
      default: false,
    },
    textLeft: {
      type: String,
      default: '',
    },
    textLeftTooltip: {
      type: String,
      default: '',
    },
    textRight: {
      type: String,
      default: '',
    },
    textRightTooltip: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const toggle = () => {
      emit('toggle', !props.currentValue);
    };

    return {
      toggle,
    };
  },
});
</script>

<style scoped>
.toggle.checked .bg {
  @apply bg-primary;
}

.toggle:not(.checked) .dot {
  @apply opacity-90;
}
.toggle.checked .dot {
  transform: translateX(100%);
  @apply opacity-100;
}
</style>
